/**
 * eslint-disable no-unused-vars
 *
 * @format
 */

import React, { useEffect } from "react";
import { Container, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TextDecrypt } from "../content/TextDecrypt";

import "./Works.css";

import { useDispatch, useSelector } from "react-redux";
import {
  getApiProjects,
  getMobileProjects,
  getOtherProjects,
  getUiProjects,
  getWebProjects,
} from "../../action/notesActions";

const useStyles = makeStyles((theme) => ({
  main: {
    maxWidth: "100vw",
    marginTop: "3em",
    marginBottom: "auto",
  },
}));

export const Works = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const webProjects = useSelector((state) => state.getWebProjects);
  const { webProject } = webProjects;

  const categories = {
    ui: [],
    web: [],
    api: [],
    mobile: [],
    other: [],
  };

  //////////////////////////////////////////////////////
  useEffect(() => {
    // get();
    dispatch(getUiProjects());
    dispatch(getApiProjects());
    dispatch(getWebProjects());
    dispatch(getMobileProjects());
    dispatch(getOtherProjects());
  }, [dispatch]);
  /////////////////////////////////

  webProject?.forEach((project) => {
    const { ProjectType } = project;
    // Use a switch statement or if-else conditions to categorize projects
    switch (ProjectType) {
      case "ui":
        categories.ui.push(project);
        break;
      case "web":
        categories.web.push(project);
        break;
      case "api":
        categories.api.push(project);
        break;
      case "mobile":
        categories.mobile.push(project);
        break;
      default:
        categories.other.push(project);
    }
  });
  console.log(categories);
  console.log(webProject);

  return (
    <section id="works">
      <Container component="main" className={classes.main} maxWidth="md">
        <Typography style={{ textAlign: "center" }} variant="h2" component="h2">
          <TextDecrypt text={`${"Projects"}`} />
        </Typography>

        {/*  */}
        {/* <Typography style={{ marginLeft: "6rem" }} variant="h5" component="h2">
          <div className="category">
            <TextDecrypt text={`${"#Web"} (${categories.web?.length}) `} />
          </div>
        </Typography>

        {categories.web?.map((project, index) => (
          <div className="project" key={project?._id}>
            <div className="__img_wrapper">
              <img src={project?.ProjectImage} alt={project?.alter} />
            </div>
            <div className="__content_wrapper">
               {project?.ProjectLink?.active ? (
                <a
                  class="linktogo"
                  href={project?.ProjectLink?.url}
                  target="_blank"
                >
                  Go to 🌐
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19.638"
                    height="19.14"
                    viewBox="0 0 19.638 19.14"
                  >
                    <path
                      id="Icon_awesome-arrow-right"
                      data-name="Icon awesome-arrow-right"
                      d="M8.349,3.929l.973-.973a1.048,1.048,0,0,1,1.486,0l8.52,8.516a1.048,1.048,0,0,1,0,1.486l-8.52,8.52a1.048,1.048,0,0,1-1.486,0l-.973-.973A1.053,1.053,0,0,1,8.367,19l5.281-5.032H1.052A1.049,1.049,0,0,1,0,12.919v-1.4a1.049,1.049,0,0,1,1.052-1.052h12.6L8.367,5.433A1.046,1.046,0,0,1,8.349,3.929Z"
                      transform="translate(0 -2.647)"
                      fill="#fff"
                    ></path>
                  </svg>
                </a>
              ) : (
                <a
                  class="linktogo"
                  href="https://yeabsiras.netlify.app/#/contact"
                  target="_blank"
                >
                  Contat me
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19.638"
                    height="19.14"
                    viewBox="0 0 19.638 19.14"
                  >
                    <path
                      id="Icon_awesome-arrow-right"
                      data-name="Icon awesome-arrow-right"
                      d="M8.349,3.929l.973-.973a1.048,1.048,0,0,1,1.486,0l8.52,8.516a1.048,1.048,0,0,1,0,1.486l-8.52,8.52a1.048,1.048,0,0,1-1.486,0l-.973-.973A1.053,1.053,0,0,1,8.367,19l5.281-5.032H1.052A1.049,1.049,0,0,1,0,12.919v-1.4a1.049,1.049,0,0,1,1.052-1.052h12.6L8.367,5.433A1.046,1.046,0,0,1,8.349,3.929Z"
                      transform="translate(0 -2.647)"
                      fill="#fff"
                    ></path>
                  </svg>
                </a>
              )}
              <h3 className="title">
                <TextDecrypt text={index + 1 + ". " + project.ProjectName} />
              </h3>
              <p className="description">{project.ProjectDetails}</p>
            </div>
          </div>
        ))} */}

        {/*  */}
        {/* <Typography style={{ marginLeft: "6rem" }} variant="h5" component="h2">
          <div className="category">
            <TextDecrypt text={`${"#UI/UX"} (${categories.ui?.length}) `} />
          </div>
        </Typography>

        {categories.ui?.map((project, index) => (
          <div className="project" key={project?._id}>
            <div className="__img_wrapper">
              <img src={project.ProjectImage} alt={project?.alter} />
            </div>
            <div className="__content_wrapper">
              <h3 className="title">
                <TextDecrypt text={index + 1 + ". " + project.ProjectName} />
              </h3>
              <p className="description">{project.ProjectDetails}</p>
            </div>
          </div>
        ))} */}

        {/*  */}

        {/*  */}
        {/* <Typography style={{ marginLeft: "6rem" }} variant="h5" component="h2">
          <div className="category">
            <TextDecrypt text={`${"#API"} (${categories.api?.length}) `} />
          </div>
        </Typography>

        {categories.api?.map((project, index) => (
          <div className="project" key={project._id}>
            <div className="__img_wrapper">
              <img src={project.ProjectImage} alt={project?.alter} />
            </div>
            <div className="__content_wrapper">
              <h3 className="title">
                <TextDecrypt text={index + 1 + ". " + project.ProjectName} />
              </h3>
              <p className="description">{project.ProjectDetails}</p>
            </div>
          </div>
        ))} */}

        {/*  */}

        {/*  */}
        {/* <Typography style={{ marginLeft: "6rem" }} variant="h5" component="h2">
          <div className="category">
            <TextDecrypt
              text={`${"#Mobile"} (${categories.mobile?.length}) `}
            />
          </div>
        </Typography>

        {categories.mobile?.map((project, index) => (
          <div className="project" key={project._id}>
            <div className="__img_wrapper">
              <img src={project.ProjectImage} alt={project?.alter} />
            </div>
            <div className="__content_wrapper">
              <h3 className="title">
                <TextDecrypt text={index + 1 + ". " + project.ProjectName} />
              </h3>
              <p className="description">{project.ProjectDetails}</p>
            </div>
          </div>
        ))} */}

        {/*  */}

        {/* {projects.map((project) => (
          <div className="project" key={project.id}>
            <div className="__img_wrapper">
              <img src={project.image} alt={project.alter} />
            </div>
            <div className="__content_wrapper">
              <h3 className="title">
                <TextDecrypt text={project.id + ". " + project.title} />
              </h3>
              <p className="description">{project.description}</p>
            </div>
          </div>
        ))} */}

        <CategoryContainer categoryTitle="#Web" projects={categories.web} />
        <CategoryContainer categoryTitle="#UI/UX" projects={categories.ui} />
        <CategoryContainer categoryTitle="#API" projects={categories.api} />
        <CategoryContainer
          categoryTitle="#Mobile"
          projects={categories.mobile}
        />
      </Container>
    </section>
  );
};

const CategoryContainer = ({ categoryTitle, projects }) => {
  const filteredProjects = projects?.filter(
    (project) => project.Status === true
  );

  // console.log({ projects, filteredProjects });
  return (
    <div>
      <Typography style={{ marginLeft: "6rem" }} variant="h5" component="h2">
        <div className="category">
          <TextDecrypt
            text={`${categoryTitle} (${filteredProjects?.length})`}
          />
        </div>
      </Typography>

      {filteredProjects?.map((project, index) => (
        <div className="project" key={project._id}>
          <div className="__img_wrapper">
            <img src={project.ProjectImage} alt={project?.alter} />
          </div>
          <div className="__content_wrapper">
            {project?.ProjectLink?.active ? (
              <a
                class="linktogo"
                href={project?.ProjectLink?.url}
                target="_blank"
              >
                Go to 🌐
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19.638"
                  height="19.14"
                  viewBox="0 0 19.638 19.14"
                >
                  {/* Add your SVG path here */}
                </svg>
              </a>
            ) : (
              <a
                class="linktogo"
                href="https://yeabsiras.netlify.app/#/contact"
                target="_blank"
              >
                Contact me
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19.638"
                  height="19.14"
                  viewBox="0 0 19.638 19.14"
                >
                  {/* Add your SVG path here */}
                </svg>
              </a>
            )}
            <h3 className="title">
              <TextDecrypt text={index + 1 + ". " + project.ProjectName} />
            </h3>
            <p className="description">{project.ProjectDetails}</p>
            <p
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              {project?.ProjectHash &&
                project?.ProjectHash.map((skill) => (
                  <span
                    style={{
                      padding: "0.25rem 1rem",
                      background: "white",
                      borderRadius: "50px",
                      color: "#000",
                      margin: "7px",
                    }}
                  >
                    #{skill}
                  </span>
                ))}
            </p>
            {/* <div className="Dev">
            </div> */}
          </div>
        </div>
      ))}
    </div>
  );
};
